import { useEffect, useState } from 'react';
import { HelpCircle } from 'lucide-react';
import {
  HELP_EVENT_TRIGGER,
  TOUR_ACTIVE_EVENT,
  TOUR_INACTIVE_EVENT,
} from '@/components/hooks/usePageHelp';

const HELP_EVENT_REGISTER = 'bookoll:help-available';
const HELP_EVENT_UNREGISTER = 'bookoll:help-unavailable';

export default function HelpButton() {
  const [disponible, setDisponible] = useState(false);
  const [tourActivo, setTourActivo] = useState(false);

  useEffect(() => {
    const onRegister = () => setDisponible(true);
    const onUnregister = () => setDisponible(false);
    window.addEventListener(HELP_EVENT_REGISTER, onRegister);
    window.addEventListener(HELP_EVENT_UNREGISTER, onUnregister);
    return () => {
      window.removeEventListener(HELP_EVENT_REGISTER, onRegister);
      window.removeEventListener(HELP_EVENT_UNREGISTER, onUnregister);
    };
  }, []);

  useEffect(() => {
    const onActive = () => setTourActivo(true);
    const onInactive = () => setTourActivo(false);
    window.addEventListener(TOUR_ACTIVE_EVENT, onActive);
    window.addEventListener(TOUR_INACTIVE_EVENT, onInactive);
    return () => {
      window.removeEventListener(TOUR_ACTIVE_EVENT, onActive);
      window.removeEventListener(TOUR_INACTIVE_EVENT, onInactive);
    };
  }, []);

  if (!disponible || tourActivo) return null;

  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event(HELP_EVENT_TRIGGER))}
      className="fixed z-40 right-16 shrink-0 p-2.5 rounded-full bg-white/90 dark:bg-[#1c1c1e]/90 backdrop-blur-sm border border-gray-200 dark:border-white/10 shadow-md hover:bg-white dark:hover:bg-white/10 transition"
      style={{ top: 'calc(env(safe-area-inset-top) + 1rem)' }}
      aria-label="Ayuda"
    >
      <HelpCircle className="w-5 h-5 text-[#103254] dark:text-white" />
    </button>
  );
}